import { render } from "./EmptyCallView.vue?vue&type=template&id=590eeac2&scoped=true"
import script from "./EmptyCallView.vue?vue&type=script&lang=js"
export * from "./EmptyCallView.vue?vue&type=script&lang=js"

import "./EmptyCallView.vue?vue&type=style&index=0&id=590eeac2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590eeac2"]])

export default __exports__